<template>
  <aside class="left-sidebar">
    <div class="scroll-sidebar">
      <nav class="sidebar-nav">
        <ul class="sidebarnav">
          <li class="sidebar-item">
            <router-link @click.native="onPageChange" class="sidebar-link waves-effect waves-dark" to="/dashboard" exact>
              <i class="nav-icon fas fa-th-large"></i>
              <span class="menu-text hide-menu">{{ $t('nav.home') }}</span>
            </router-link>
          </li>

          <template v-for="group in toolGroups">
            <li :key="'cap-' + group.id" class="nav-small-cap">
              <span class="hide-menu">{{ group.label }}</span>
            </li>
            <li
              v-for="item in group.items"
              :key="item.to"
              class="sidebar-item"
            >
              <router-link
                @click.native="onPageChange"
                class="sidebar-link waves-effect waves-dark"
                :to="item.to"
                active-class=""
                :class="{ 'router-link-active': isNavActive(item) }"
              >
                <i :class="['nav-icon', item.icon]"></i>
                <span class="menu-text hide-menu">{{ item.label }}</span>
              </router-link>
            </li>
          </template>
        </ul>
      </nav>
    </div>
  </aside>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('auth', ['role']),
    ...mapGetters('app', ['hideScheduler', 'hideAI']),
    toolGroups() {
      const groups = [
        {
          id: 'canva',
          label: this.$t('nav.design_studio'),
          items: [
            { id: 'designs', to: '/ai/studio', icon: 'fas fa-paint-brush', label: this.$t('nav.designs'), exact: true },
            { id: 'render-api', to: '/ai/studio/api', icon: 'fas fa-plug', label: this.$t('nav.design_studio_api') },
            { id: 'api-playground', to: '/ai/studio/playground', icon: 'fas fa-flask', label: this.$t('nav.api_playground') },
          ],
        },
        {
          id: 'social',
          label: this.$t('nav.social_scheduler'),
          items: [
            { to: '/posts/create', icon: 'fas fa-plus-circle', label: this.$t('nav.create_post') },
            { id: 'posts', to: '/posts', icon: 'fas fa-list', label: this.$t('nav.posts') },
            { to: '/posts/calendar', icon: 'fas fa-calendar-alt', label: this.$t('nav.calendar') },
            { to: '/recurring', icon: 'fas fa-redo', label: this.$t('nav.recurring') },
            { to: '/posts/approval', icon: 'fas fa-tasks', label: this.$t('nav.approval') },
            { to: '/social/accounts', icon: 'fab fa-instagram', label: this.$t('nav.accounts') },
          ],
        },
        {
          id: 'ai',
          label: this.$t('nav.ai'),
          items: [
            { to: '/ai/assistant', icon: 'fas fa-comment-dots', label: this.$t('nav.assistant') },
          ],
        },
        {
          id: 'insights',
          label: this.$t('nav.insights'),
          items: [
            { to: '/analytics', icon: 'fas fa-chart-bar', label: this.$t('nav.analytics') },
          ],
        },
        {
          id: 'workspace',
          label: this.$t('nav.workspace'),
          items: [
            { id: 'storage', to: '/storage', icon: 'fas fa-hdd', label: this.$t('nav.storage') },
            { id: 'pricing', to: '/billing', icon: 'fas fa-credit-card', label: this.$t('nav.pricing'), exact: true },
            { id: 'profile', to: '/profile', icon: 'fas fa-user', label: this.$t('nav.profile'), exact: true },
          ],
        },
      ]

      const visible = groups.filter((group) => {
        if (this.hideScheduler && (group.id === 'social' || group.id === 'insights')) return false
        if (this.hideAI && group.id === 'ai') return false
        return true
      })

      if (this.role === 'admin') {
        visible.push({
          id: 'admin',
          label: this.$t('nav.admin'),
          items: [
            { to: '/admin', icon: 'fas fa-tachometer-alt', label: this.$t('nav.admin_overview'), exact: true },
            { to: '/admin/users', icon: 'fas fa-users-cog', label: this.$t('nav.users') },
            { to: '/admin/plans', icon: 'fas fa-layer-group', label: this.$t('nav.plans') },
            { to: '/admin/integrations', icon: 'fas fa-plug', label: this.$t('nav.integrations') },
            { to: '/admin/app-review', icon: 'fas fa-clipboard-check', label: this.$t('nav.app_review') },
            { to: '/admin/canva-reports', icon: 'fas fa-flag', label: this.$t('nav.canva_reports') },
            { to: '/admin/features', icon: 'fas fa-eye-slash', label: this.$t('nav.features') },
            { to: '/admin/transactions', icon: 'fas fa-receipt', label: this.$t('nav.transactions') },
          ],
        })
      }

      return visible
    },
  },
  mounted() {
    this.initTemplate()
  },
  methods: {
    isNavActive(item) {
      const { path } = this.$route

      if (item.id === 'profile') {
        return path === '/profile'
      }
      if (item.id === 'pricing') {
        return path === '/billing'
      }
      if (item.id === 'designs') {
        if (path.startsWith('/ai/studio/api') || path.startsWith('/ai/studio/playground')) return false
        return path === '/ai/studio' || path.startsWith('/ai/studio/')
      }
      if (item.id === 'posts') {
        if (path.startsWith('/posts/create') || path.startsWith('/posts/calendar') || path.startsWith('/posts/approval')) return false
        return path === '/posts' || path.startsWith('/posts/')
      }

      const toPath = item.to.split('#')[0]
      if (item.exact) return path === toPath
      return path === toPath || path.startsWith(`${toPath}/`)
    },
    initTemplate() {
      const element = document.getElementById('main-wrapper')
      if (!element) return
      this.$adminTemplate.init(element, {
        Theme: false,
        Layout: 'vertical',
        LogoBg: 'skin6',
        NavbarBg: 'skin6',
        SidebarType: 'full',
        SidebarColor: 'skin6',
        SidebarPosition: true,
        HeaderPosition: true,
        BoxedLayout: false,
      })
      this.$adminTemplate.preloader()
      this.$adminTemplate.expandLogo()
    },
    onPageChange() {
      this.$adminTemplate.handleSidebarMobile(true)
    },
  },
}
</script>
